import React, { useState } from 'react'
import '../../index.css'
import { RenderImage } from './ImageView'

/**
 * Component to upload an image for an articletype.
 * @param {any} setFilename hook to set the fileName
 * @param {any} setImage hook to set the image as binary
 */
const UploadImage = ({ setFilename, setImage }) => {
    const [previewImage, setPreviewImage] = useState()

    /**
     * Checks if the selected image has the correct format, calls "openFiles" if correct
     * Used code for arrayBuffer and binary parsing: https://stackoverflow.com/questions/9267899/arraybuffer-to-base64-encoded-string
     * @param {any} imageInput image selected by the user
     */
    const handleChange = (imageInput) => {
        if (imageInput.target.files[0]) {
            const file = imageInput.target.files[0]
            var pattern = /image-*/;

            if (!file.type.match(pattern)) {
                alert(window.i18n('errorImage'))
                return;
            }

            setPreviewImage(URL.createObjectURL(file))
            openFiles(imageInput)
        }
    }

    //gets called when an image was selected by the user
    //writes image data into a binarystring; reader is called via callback (line 49) if the file selection changes
    function openFiles(evt) {
        var file = evt.target.files[0]
        setFilename(file.name)

        var reader = new FileReader()

        reader.onload = (function (f) {
            return function (e) {
                var arrayBuffer = e.target.result
                var bytes = new Uint8Array(arrayBuffer)
                var binary = ''

                var len = bytes.byteLength;
                for (var i = 0; i < len; i++) {
                    binary += String.fromCharCode(bytes[i])
                }
                var binaryString = btoa(binary);
                setImage(binaryString)
            };
        })(file)

        reader.readAsArrayBuffer(file)
    }

    //input field to open a file picker
    //shows image to be uploaded as preview thumbnail
    return (
        <div className="form-inline">
            <input required className="form-control" type="file" onChange={handleChange} accept="image/*" />
            &nbsp;
            {previewImage != null && RenderImage(previewImage)}
        </div>
    );
}

export default UploadImage